var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { _get } from '@/common/request';
import { switchCompany } from '@/views/company/api';
import { BUCKETS } from '@/common/utils/qiniu-constant';
import { isObject } from '@lhb/func';
import { setStorage, removeStorage, setCookie } from '@lhb/cache';
export default {
    state: {
        user: {},
        provinceList: null,
        tab: 'workbench',
        storeInfo: [],
        requireAuth: false,
        permission: {},
        companyId: '',
        manageCompanyId: '',
        defaultBg: '',
        addBoothKey: null,
        qiniuToken: {},
        menuList: [],
        companies: []
    },
    actions: {
        // 异步获取省市区列表
        $_GetProvinceList: function (_a) {
            var commit = _a.commit, state = _a.state;
            if (state.provinceList) {
                return Promise.resolve(state.provinceList);
            }
            else {
                return new Promise(function (resolve, reject) {
                    _get('/property/areas', {}, { isMock: false, needCancel: false }).then(function (data) {
                        commit('UPDATE_PROVINCE_LIST', data);
                        resolve(data);
                    }, function (err) {
                        reject(err);
                    });
                });
            }
        },
        // 动态更新用户信息
        $_UpdateUserInfo: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                _get('/property/user/info', null, true).then(function (user) {
                    commit('UPDATE_USER', user);
                    resolve(user);
                }, function (err) {
                    reject(err);
                });
            });
        },
        // 动态更新用户信息
        $_UpdateCompanyList: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                _get('/property/user/companies', null, true).then(function (data) {
                    commit('UPDATE_COMPANIES', data);
                    resolve(data);
                }, function (err) {
                    reject(err);
                });
            });
        },
        // 动态更新权限信息
        $_UpdatePermission: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                _get('/property/user/permissions', null, true).then(function (permission) {
                    commit('UPDATE_PERMISSION', permission);
                    resolve(permission);
                }, function (err) {
                    reject(err);
                });
            });
        },
        // 切换公司
        $_UserSwitchCompany: function (_a, params) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                setStorage('getTokenApi', '/property/user/change-company');
                switchCompany(params).then(function (data) {
                    commit('UPDATE_USER_DETAIL', __assign({}, data));
                    resolve(data);
                }, function (err) {
                    reject(err);
                });
            });
        },
        // 动态更新七牛上传token
        $_UpdateQiniuToken: function (_a, type) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                _get("/v1/api/qiniu/token/" + BUCKETS[type], {
                    allowRepeat: true,
                }, { needPrefix: false }).then(function (_a) {
                    var _b;
                    var token = _a.token;
                    commit('UPDATE_QINIUTOKEN', (_b = {},
                        _b[type] = {
                            token: token,
                            expiry: new Date().getTime() + 3500 * 1000,
                        },
                        _b));
                    resolve(token);
                }, function (err) {
                    reject(err);
                });
            });
        },
    },
    mutations: {
        // 保存用户详细信息
        UPDATE_USER_DETAIL: function (state, data) {
            state.companyId = data.companyId;
            state.user = __assign({ external_system: 0 }, data);
            if (process.env.NODE_ENV !== 'development') { // 开发环境屏蔽
                if (isObject(data.token)) { // 如果是对象，就上报
                    // 主动send事件
                    window.LHBbigdata.send({
                        event_id: 'location_pms_pc_cookie_monitoring_token',
                        msg: data,
                    });
                }
            }
            setCookie('newPmsCompanyId', data.companyId);
            setCookie('newPmsUserId', data.id);
            setCookie('newPmsToken', data.token);
            setStorage('newPmsToken', data.token);
            setCookie('source', 'PMS');
        },
        // 更新登录用户信息
        UPDATE_COMPANIES: function (state, data) {
            state.companies = data;
        },
        // 更新登录用户信息
        UPDATE_USER: function (state, data) {
            state.user = __assign({ external_system: 0 }, data);
        },
        // 更新用户名称
        UPDATE_USER_NAME: function (state, data) {
            Object.assign(state.user, {
                name: data,
            });
        },
        UPDATE_PROVINCE_LIST: function (state, newList) {
            state.provinceList = newList;
        },
        // header的导航
        SET_TAB: function (state, data) {
            state.tab = data;
        },
        // 更新门店信息
        UPDATE_STORE: function (state, data) {
            removeStorage('scheduleFilter'); // 清除档期管理的高级搜索
            state.storeInfo = data;
        },
        // 更新侧边栏菜单
        UPDATE_MENU: function (state, data) {
            state.menuList = data;
        },
        // 是否需要登录才能访问的页面
        REQUIRE_AUTH: function (state, data) {
            state.requireAuth = data;
        },
        // 更新权限
        UPDATE_PERMISSION: function (state, data) {
            state.permission = data;
        },
        // 公司id
        UPDATE_COMPANY_ID: function (state, data) {
            state.companyId = data;
        },
        // 管理后台跳转的公司id
        UPDATE_MANAGE_COMPANY_ID: function (state, data) {
            state.manageCompanyId = data;
        },
        // 改变默认背景
        CHANGE_BG: function (state, data) {
            state.defaultBg = data;
        },
        // 改变默认背景
        ADD_BOOTH: function (state, data) {
            state.addBoothKey = data;
        },
        // 更新七牛上传token
        UPDATE_QINIUTOKEN: function (state, data) {
            state.qiniuToken = __assign(__assign({}, state.qiniuToken), data);
        },
        // 重置state
        RESET_STATE: function (state) {
            for (var stateItem in state) {
                if (stateItem === 'requireAuth') {
                    state[stateItem] = false;
                }
                else if (stateItem === 'tab') {
                    state[stateItem] = 'workbench';
                }
                else {
                    state[stateItem] = null;
                }
            }
        },
    },
    getters: {
        /**
         * 判断按钮是否有权限
         * @param state state
         * @param btn 按钮名
         */
        hasAuth: function (state) { return function (btn) {
            var permissions = state.permission || {};
            return permissions[btn] || false;
        }; },
        getStoreInfo: function (state) {
            return state.storeInfo || [];
        },
        getUserInfo: function (state) {
            return state.user || {};
        },
        getAddBoothKey: function (state) {
            return state.addBoothKey || null;
        },
        getQiniuToken: function (state) {
            return state.qiniuToken || {};
        },
    },
};
